import { createFileRoute } from '@tanstack/react-router'
import { FlaggedIssues } from '@/features/flagged-issues'

export const Route = createFileRoute('/_authenticated/flagged-issues/')({
  component: FlaggedIssues,
})
